import { DomainModel, secureRandomString } from 'domains/models';
import { TaxInclusive } from './tax_inclusive';
import { TaxType } from './tax_type';

export default class TaxRate extends DomainModel {
  uid: string;
  teamId: number;
  taxType: TaxType;
  taxInclusive: TaxInclusive;
  percentage: number;

  constructor(props: any) {
    super(props);
    this._className = 'TaxRate';
    this.uid = props.uid;
    this.teamId = props.teamId;
    this.taxType = props.taxType;
    this.taxInclusive = props.taxInclusive;
    this.percentage = props.percentage;
  }

  static permited = ['taxType', 'taxInclusive', 'percentage'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  static defaultTaxRate(id: number | null) {
    if (id === 1) {
      // 消費税10%内税
      return new TaxRate({
        id: 1,
        uid: 'defaultTaxRate1',
        taxType: TaxType.SalesTax,
        taxInclusive: TaxInclusive.Inclusive,
        percentage: 10,
      });
    }

    return null;
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    const p = '';

    return super.isValid();
  }
}
